module.exports = __webpack_public_path__ + "static/media/mapicc_medium@2x.130ff4cb.jpg";